export const DATE_MASK_TEMPLATE = 'MM/DD/YYYY';

export const DATETIME_MASK_TEMPLATE = 'MM/DD/YYYY HH:mm';

export const YEAR_MASK_TEMPLATE = 'YYYY';

export const DIGIT_PLACEHOLDER_CHARS = new Set(['M', 'D', 'Y', 'H', 'm']);

export const DIGIT_REGEX = /^\d$/;

export const INVALID_DATE_INPUT_ATTRIBUTE = 'data-invalid-date';

const MONTH_SECTION = { key: 'month', start: 0, end: 2, min: 1, max: 12 };
const DAY_SECTION = { key: 'day', start: 3, end: 5, min: 1, max: 31 };
const YEAR_SECTION = { key: 'year', start: 6, end: 10, min: 1000, max: 9999 };
const HOUR_SECTION = { key: 'hour', start: 11, end: 13, min: 0, max: 23 };
const MINUTE_SECTION = { key: 'minute', start: 14, end: 16, min: 0, max: 59 };
const YEAR_ONLY_SECTION = { key: 'year', start: 0, end: 4, min: 1000, max: 9999 };

export const TIME_SELECTION_FINISH_STATE = 'finish';

export const MASK_SECTIONS_BY_TEMPLATE = {
  [DATE_MASK_TEMPLATE]: [MONTH_SECTION, DAY_SECTION, YEAR_SECTION],
  [DATETIME_MASK_TEMPLATE]: [
    MONTH_SECTION,
    DAY_SECTION,
    YEAR_SECTION,
    HOUR_SECTION,
    MINUTE_SECTION,
  ],
  [YEAR_MASK_TEMPLATE]: [YEAR_ONLY_SECTION],
};
